/** 浏览器内的登录周期快照；凭证只用于内存比较，不进入日志或缓存键。 */
interface SessionSnapshot {
  token: string | null;
  userId: string | null;
  platform: string | null;
  scope: string;
}

let snapshot: SessionSnapshot | null = null;
let generation = 0;

/** 返回当前登录周期标识；跨标签页换凭证、换用户或换平台时自动失效。 */
export function getAuthSessionScope(): string {
  const token = localStorage.getItem('boclaw_token');
  const userId = localStorage.getItem('boclaw_user_id');
  // 构建时的默认平台不会在页面生命周期内改变，只需监听运行时覆盖值。
  const platform = localStorage.getItem('platform_base_url');
  if (!snapshot || snapshot.token !== token || snapshot.userId !== userId || snapshot.platform !== platform) {
    snapshot = { token, userId, platform, scope: `auth-session-${++generation}` };
  }
  return snapshot.scope;
}

/** 真正退出或重新登录时作废旧周期，即使同账号拿到相同凭证也不能复用旧请求。 */
export function invalidateAuthSessionScope(): void {
  snapshot = null;
}

/**
 * 原子接收当前周期的续期凭证，保留请求和连接的身份标识。
 * expectedScope/previousToken 必须来自请求发起时；不匹配则返回 false，不修改存储。
 */
export function acceptAuthTokenRenewal(expectedScope: string, previousToken: string, nextToken: string): boolean {
  if (getAuthSessionScope() !== expectedScope || snapshot?.token !== previousToken) return false;
  localStorage.setItem('boclaw_token', nextToken);
  snapshot.token = nextToken;
  return true;
}
